module.exports = __webpack_public_path__ + "img/neck_width.9781e39c.png";